/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Layout from 'components/Layout';
import { FitinsurAPI } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import StepNavigation from 'components/StepNavigation'
import {
    FileModal
} from '@fitinsur/components';

import {
    Content,
} from './styles';
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import BrokingSummary from 'components/BrokingSummary';
import {
    LoaderContext
} from '@fitinsur/contexts'
import { useGetOperations } from 'services/OperationService';
import { useGetDocuments } from 'services/DocumentsService';

export default function QuoteDocument(props) {
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const history = useHistory();
    const [operation, setOperation] = useState({});
    const [documents, setDocuments] = useState([])

    const {
        data: useGetOperationsData,
        loading: useGetOperationsLoading,
        error: useGetOperationsError,
        status: useGetOperationsStatus,
        request: useGetOperationsRequest,
    } = useGetOperations();

    const {
        data: useGetDocumentsData,
        loading: useGetDocumentsLoading,
        error: useGetDocumentsError,
        status: useGetDocumentsStatus,
        request: useGetDocumentsRequest
    } = useGetDocuments(operation?.idOperation);


    useEffect(() => {
        if (useGetOperationsStatus === 200) {
            const [operation] = useGetOperationsData?.value
            setOperation(operation)
        }
    }, [useGetOperationsStatus]);

    useEffect(() => {
        if (useGetDocumentsStatus === 200) {
            setDocuments(useGetDocumentsData?.value?.reverse())
        }
    }, [useGetDocumentsStatus]);


    useEffect(() => {
        updateIsLoadingStatus(
            useGetOperationsLoading ||
            useGetDocumentsLoading
        )
    }, [
        useGetOperationsLoading,
        useGetDocumentsLoading
    ]);

    useEffect(() => {
        useGetOperationsRequest(null, { idDomain: [27], idOperationRoot: props.match?.params?.idOperation })
    }, [])

    useEffect(() => {
        if (operation?.idOperation) useGetDocumentsRequest()
    }, [operation])

    return (
        <Layout
            title={"Documento de cotação"}
            subtitle={`${operation?.productName || ""}`}
        >
            <Row>
                <Col>
                    <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} idProduct={props.match?.params?.idProduct} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <BrokingSummary
                        history={history}
                        idOperation={props.match?.params?.idOperation}
                        idProduct={props.match?.params?.idProduct} />
                </Col>
            </Row>

            <Content>
                <FileModal documents={documents} />
            </Content>
        </Layout >
    )
}
